<script setup lang="ts">
  import { Icon } from '@/components';

  interface StarsProps {
    modelValue: number;
    stars?: number;
    color?: string;
  }

  withDefaults(defineProps<StarsProps>(), {
    stars: 5,
    color: 'var(--color-orange-40)',
  });
</script>

<script lang="ts">
  export default {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };
</script>

<template>
  <div class="tl-stars">
    <Icon
      v-for="star in stars"
      :key="star"
      name="star"
      size="xs"
      :style="{ stroke: color, fill: star <= modelValue ? color : 'none' }"
      data-test-id="icon"
    />
  </div>
</template>

<style lang="scss" scoped>
  .tl-stars {
    align-items: center;
    display: flex;
    gap: var(--spacing-xxxs);
  }
</style>
